module.exports = __webpack_public_path__ + "static/img/GettyImages-688024767.ac0f426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/GettyImages-688024767.jpg
// module id = OU8H
// module chunks = 0